export default __webpack_public_path__ + "static/media/baricarplast.b7218b34.png";